import React, { useEffect } from "react";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      {/* Header Section */}
      <div className="flex justify-center py-10 lg:py-20 bg-gradient-to-r from-green-200 via-indigo-100 to-green-100 w-full bg-cover bg-no-repeat bg-bottom">
        <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
          <div className="w-full flex justify-center flex-col relative">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-center text-gray-800 tracking-tight drop-shadow-md">
              About Us
            </h2>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="bg-white">
        <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
          {/* Glass Effect Card */}
          <div className="bg-white/80 backdrop-blur-md shadow-xl rounded-2xl p-6 sm:p-10 border border-gray-200">
            <div className="prose prose-sm sm:prose lg:prose-lg max-w-none">

              {/* INSERTED CONTENT */}
              <p className="text-gray-700 leading-relaxed mb-8">
                <span className="font-bold text-green-600">ASHTEN GLOBAL</span>, Manufacturer,
                authorized distributor and trusted partner for a wide range of laboratory chemicals,
                Personal Care, Food, Water Treatment, Aquaculture, Rubber, reagents, and allied
                products. With years of expertise in serving Cleaning, Feed, Pharma Grade, Agro,
                Paint, RO Membranes, research institutions, industrial laboratories, and academic
                organizations, we are committed to ensuring reliable supply, competitive pricing, and
                uncompromised quality.
              </p>

              <h4 className="text-xl font-semibold text-gray-900 mb-3">
                Our product portfolio includes:
              </h4>

              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-10">
                <li>High-purity laboratory chemicals & solvents</li>
                <li>Analytical reagents (AR/GR grade)</li>
                <li>Specialty chemicals for pharma & biotech applications</li>
                <li>Standards, buffers, and solutions</li>
                <li>Preservatives & Biocides</li>
              </ul>
              {/* END INSERT */}

              {/* FIRST MAIN HEADLINE */}
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Innovating Chemical Solutions for a Sustainable Future
              </h3>

              <p className="text-gray-700 leading-relaxed">
                At{" "}
                <span className="font-bold text-green-600">Ashten Global</span>, we are committed to
                delivering a comprehensive suite of chemical products tailored to meet the diverse
                needs of industries worldwide. Our extensive portfolio includes:
              </p>

              {/* Product Categories */}
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-4">
                <li>
                  <strong>Advanced Detergents & Cleaning Agents:</strong> High-efficiency laundry
                  detergents, heavy-duty industrial degreasers, surface and floor sanitizers,
                  dishwashing liquids, and machine cleaners.
                </li>
                <li>
                  <strong>Disinfectants & Sanitizers:</strong> Hospital-grade surface disinfectants,
                  alcohol-based hand sanitizers, aromatic sprays, and cleaners.
                </li>
                <li>
                  <strong>Personal Care & Cosmetic Ingredients:</strong> Body washes, shampoos,
                  conditioners, skin care actives, emulsifiers, fragrances, and essential oils.
                </li>
                <li>
                  <strong>Adhesives & Textile Chemicals:</strong> Industrial adhesives, textile
                  auxiliaries, dyes, pigments, and finishing agents.
                </li>
                <li>
                  <strong>Food-Grade Chemicals:</strong> Preservatives, thickeners, stabilizers,
                  emulsifiers, food-grade colors, and flavors.
                </li>
                <li>
                  <strong>Natural Extracts & Plant-Based Ingredients:</strong> Herbal extracts,
                  oils, butters, proteins, and fibers.
                </li>
              </ul>

              {/* Mission */}
              <h3 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">Our Mission</h3>
              <p className="text-gray-700 leading-relaxed">
                To safely and responsibly export chemicals that drive global innovation across
                industries while fostering long-term partnerships built on trust, quality, and
                ethical sourcing.
              </p>

              {/* Vision */}
              <h3 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">Our Vision</h3>
              <p className="text-gray-700 leading-relaxed">
                To be a leading global facilitator of chemicals, driving sustainable growth through
                innovation, responsible sourcing, and exceptional customer partnerships.
              </p>

              {/* Values */}
              <h3 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">Our Values</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>
                  <strong>Innovation:</strong> Leveraging the latest research and technology.
                </li>
                <li>
                  <strong>Sustainability:</strong> Prioritizing biodegradable ingredients and
                  eco-friendly practices.
                </li>
                <li>
                  <strong>Quality Assurance:</strong> Rigorous quality control for safety and
                  performance.
                </li>
                <li>
                  <strong>Customer Focus:</strong> Customer needs drive product development.
                </li>
                <li>
                  <strong>Integrity:</strong> Committed to ethical and transparent processes.
                </li>
                <li>
                  <strong>Teamwork:</strong> Collaboration, trust, and support within every team.
                </li>
              </ul>

              {/* Why Choose Us */}
              <h3 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">Why Choose Us?</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Comprehensive Product Range</li>
                <li>Global Reach with international standards</li>
                <li>Sustainability Focus</li>
                <li>Strict Quality Assurance</li>
              </ul>

              {/* Achievements */}
              <h3 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">Our Achievements</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>ISO 14001:2015 Environmental Compliance</li>
                <li>Recognized as a Star Export House (Govt. of India)</li>
                <li>Developed 50+ new chemical formulations in 5 years</li>
                <li>Zero-waste policy with 30% waste reduction</li>
                <li>Presence in 25+ countries</li>
              </ul>

              {/* Capabilities */}
              <h3 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">Our Capabilities</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>🌐 Global Export Network – Asia, Europe, Africa, Americas</li>
                <li>✅ Compliance with International Standards</li>
                <li>🚢 Efficient Logistics Management</li>
                <li>📦 Customized Packaging Solutions</li>
                <li>🏭 Direct Sourcing from Manufacturers</li>
                <li>📊 Real-Time Order Tracking</li>
                <li>🧾 Documentation & Customs Clearance</li>
                <li>🌱 Sustainable Export Practices</li>
                <li>🤝 Strong Partner Network</li>
                <li>🕒 24/7 Customer Support</li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
